import React from 'react';
import { Link } from 'react-router-dom';
import { FaGithub, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white mt-auto">
      <div className="container-wide py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Science Forum</h3>
            <p className="text-gray-300 text-sm">
              A platform for discussing scientific papers with threaded comments.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/" className="hover:text-white">Home</Link>
              </li>
              <li>
                <Link to="/papers" className="hover:text-white">Browse Papers</Link>
              </li>
              <li>
                <Link to="/register" className="hover:text-white">Join the Community</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Citation Formats</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>APA</li>
              <li>MLA</li>
              <li>Chicago</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a href="https://github.com" className="text-gray-300 hover:text-white">
                <FaGithub size={24} />
              </a>
              <a href="https://twitter.com" className="text-gray-300 hover:text-white">
                <FaTwitter size={24} />
              </a>
              <a href="https://linkedin.com" className="text-gray-300 hover:text-white">
                <FaLinkedin size={24} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
          <p>&copy; {year} Science Forum. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 